/** ChartPanel wrapper for the Proposal page — includes MA toggle + legend. */
import Chart from "@/components/Chart";

export default function ProposalChart({
  bars, timeframe, onTimeframeChange, overlays, loading, showMAs, onToggleMAs,
}) {
  return (
    <div className="lg:col-span-9 bg-card">
      <Chart
        bars={bars}
        timeframe={timeframe}
        onTimeframeChange={onTimeframeChange}
        overlays={overlays}
        loading={loading}
        height={420}
      />
      <div className="flex items-center gap-3 px-3 h-8 border-t border-border/60 text-[10px] mono uppercase tracking-widest text-muted-foreground flex-wrap">
        <label className="flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" checked={showMAs} onChange={(e) => onToggleMAs(e.target.checked)} aria-label="Toggle 20 and 50 SMA overlays"/> 20/50 SMA
        </label>
        <span className="mx-2 opacity-40" aria-hidden="true">|</span>
        <span className="flex items-center gap-1"><span className="w-2 h-0.5 bg-[#0A84FF]" aria-hidden="true"/>ENTRY</span>
        <span className="flex items-center gap-1"><span className="w-2 h-0.5 bg-signal-red" aria-hidden="true"/>STOP</span>
        <span className="flex items-center gap-1"><span className="w-2 h-0.5 bg-signal-green" aria-hidden="true"/>TARGET</span>
        <span className="flex items-center gap-1"><span className="w-2 h-0.5 border-b border-dashed border-muted-foreground" aria-hidden="true"/>S/R</span>
        <span className="flex items-center gap-1"><span className="w-2 h-0.5 border-b border-dashed border-signal-red" aria-hidden="true"/>INVALIDATION</span>
      </div>
    </div>
  );
}
